import { useDispatch } from "react-redux";
import { setLiveAgentUnavailable, setRetryLiveAgent } from "../../../features/liveAgentSlice";

export default function RetryLiveAgentButton() {
    const dispatch = useDispatch();

    const handleRetryLiveAgent = () => {
        dispatch(setRetryLiveAgent(true));
        dispatch(setLiveAgentUnavailable(false));
    };

    return (
        <button onClick={ handleRetryLiveAgent }>
            Retry Live Agent
        </button>
    );
};
